import { LitElement, html, css } from 'lit'
import { ProgressBar } from './progress-bar'
import { centsToDollars } from '../../lib/utils'
export class FreeShippingProgress extends LitElement {
  static styles = [
    css`
      :host {
        display: block;
      }

      .free-shipping-progress {
        padding: 0 20px;
        display: flex;
        column-gap: 12px;
      }

      .free-shipping-progress p {
        font-size: 12px;
        text-align: center;
        margin: 0;
        white-space: nowrap;
      }

      .free-shipping-progress-bar progress-bar {
        width: 100%;
        margin: 0 10px;
        font-size: 14px;
      }

      .free-shipping-progress-bar {
        display: flex;
        align-items: center;
        width: 100%;
      }

      .free-shipping-progress-bar .min-num,
      .free-shipping-progress-bar .max-num {
        color: #978f90;
        font-size: 14px;
      }
    `,
  ]

  static properties = {
    subtotal: { type: Number },
    freeShippingMin: { type: Number, attribute: 'free-shipping-min' },
    enabledText: { type: String, attribute: 'enabled-text' },
  }

  connectedCallback() {
    super.connectedCallback()
    this.subtotal = this.subtotal ?? 0
    this.freeShippingMin = this.freeShippingMin ?? 75
    this.enabledText = this.enabledText ?? `You've reached free shipping!`
    window.MicroBus.on('shipscout:response', ({ detail }) => {
      const { thresholdCents } = detail
      this.freeShippingMin = centsToDollars(thresholdCents)
    })
  }

  _renderFreeShippingText() {
    if (this.enabledText !== 'false') {
      const spendToFreeShipping = Math.round(this.freeShippingMin - this.subtotal)
      if (this.subtotal > this.freeShippingMin) {
        return html`<p>${this.enabledText}</p>`
      } else {
        return html`<p>You’re $${spendToFreeShipping} away from free shipping.</p>`
      }
    }
  }

  render() {
    return html`
      <div class="free-shipping-progress">
        ${this._renderFreeShippingText()}
        <div class="free-shipping-progress-bar">
          <progress-bar value=${Math.round((this.subtotal / this.freeShippingMin) * 100)}></progress-bar>
        </div>
      </div>
    `
  }
}
customElements.define('free-shipping-progress', FreeShippingProgress)
